import React from "react";

interface TypeStepHeaderProps {
  title?: string;
  badge?: string;
  intro?: string;
}

const StepHeader: React.FC<TypeStepHeaderProps> = ({ title, badge, intro }) => {
  if (!badge && !intro) {
    return <p>{title}</p>;
  }

  return (
    <>
      <div className="layout-profile-ctx-title">
        <p>{title}</p>
        {badge ? <span className="layout-profile-ctx-badge">{badge}</span> : null}
      </div>
      {intro ? <p className="layout-profile-ctx-intro">{intro}</p> : null}
    </>
  );
};

export default StepHeader;
